import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Transaction {
  id: string;
  receiptId: string;
  date: string;
  // Add other properties as needed based on your data structure
  [key: string]: any; // This allows for additional properties
}

interface TransactionHistoryProps {
  hideUserColumn?: boolean;
  transactionsData: Transaction[];
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({
  hideUserColumn,
  transactionsData,
}) => {
  const navigate = useNavigate();

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Receipt ID</TableCell>
            <TableCell>Transaction Date</TableCell>
            {!hideUserColumn && <TableCell>User</TableCell>}
            {/* <TableCell>Source</TableCell> */}
            {/* <TableCell>Type</TableCell> */}
            <TableCell>Amount</TableCell>
            <TableCell>Transaction Status</TableCell>
            {/* <TableCell>Actions</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {transactionsData?.map((tx: Transaction) => (
            <TableRow key={tx.id}>
              <TableCell>{tx.referenceId}</TableCell>

              <TableCell>
                {new Date(tx.transactionDate).toLocaleDateString("en-GB")}
              </TableCell>
              {!hideUserColumn && (
                <TableCell>
                  <Box
                    component="a"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/manage-users/detail/${tx?.userId?._id}`);
                    }}
                    className="user_block click_action"
                  >
                    <p>
                      {" "}
                      <b> {tx?.userId?.fullName}</b>{" "}
                      <span>{tx?.userId?.phone}</span>{" "}
                      <span>{tx?.userId?.email}</span>{" "}
                    </p>
                  </Box>
                </TableCell>
              )}
              {/* <TableCell>{tx.store}</TableCell>

              <TableCell>{tx.type}</TableCell> */}
              <TableCell>
                <p
                // className={`status_btn ${tx.points > 0 ? "c_success" : "c_danger"
                // }`}
                >
                  <span>{`${tx?.amount} ${tx?.currency}`}</span>
                  {/* {`${tx.points > 0 ? "+" : ""}${tx.points} pts`} */}
                </p>
              </TableCell>

              <TableCell>
                <p
                  className={`status_btn dark ${
                    tx?.product?.status === 2
                      ? "c_success"
                      : tx?.product?.status === 3
                      ? "c_danger"
                      : "c_warning"
                  }`}
                >
                  {tx?.product?.status === 1
                    ? "Pending"
                    : tx?.product?.status === 2
                    ? "Approved"
                    : "Rejected"}
                </p>
              </TableCell>
              {/* <TableCell>
                <div className="table_actions v2">

                  <Box>

                    <IconButton
                      onClick={() => navigate("/manage-payments/view")}>
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                  </Box>
                </div>
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionHistory;
